import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import './sass/main.scss';
import Home from './Components/Home';
import HeaderMobileMode from './Components/headerMobileMode';
import FirstPage from './Components/FirstPage';
import Projects from './Components/Projects';
import Skills from './Components/Skills';
import Education from './Components/Education';
import Courses from './Components/Courses';
import Work from './Components/Work';
import Recommendations from './Components/Recommendations';
import About from './Components/About';
import * as reveal from './Layouts/Reveal';

import { ScrollToTop } from './Layouts/ScrollToTop';
import Resume from './Components/Resume';

import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));

window.addEventListener('scroll', reveal.reveal);
window.addEventListener('scroll', reveal.revealFromLeft);

root.render(
  <React.StrictMode>
    <Router>
      <div className='container'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/header' element={<FirstPage />} />
          <Route path='/headerMobileMode' element={<HeaderMobileMode />} />
          <Route path='/about' element={<About />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/education' element={<Education />} />
          <Route path='/skills' element={<Skills />} />
          <Route path='/work' element={<Work />} />
          <Route path='/courses' element={<Courses />} />
          <Route path='/recommendations' element={<Recommendations />} />
          <Route path='/resume' element={<Resume />} />

          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </div>
    </Router>
    <ScrollToTop />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
